import BaseModelAPI from '../BaseModelAPI';

export default class NextProcess extends BaseModelAPI {
	static entity = 'nextprocess';
	static entityName = 'nextprocess';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}